export default "__VITE_ASSET__BMkjlyrZ__"